<template>
    <div
    >
        <HeaderTopComponent  v-if="!menuMovil" />
        <MenuComponent 
            background='' 
            :dense='false' 
            styleRow='margin-top: 0px'
            v-if="!menuMovil"
        />
        <MenuMovilComponent v-if="menuMovil" class='px-6 px-sm-10'/>
        <v-img 
            :src="`${require('@/assets/banner-contacto.png')}`" 
            v-if="$route.path != ''"
            :class="`${scrollTop ? '' : 'mt-132'}`"
        />
        <BreadCrumbsComponent  :breadcrumbs="breadcrumbs" class="margin-breadcrumb"/>
        <div class='col-md-8 mx-md-5 mx-md-10 mx-md-16  px-md-16 my-6'>
            <h1 class="orange--text font-title"><i>Haga su consulta</i></h1>
        </div>
        <div class='col-md-8 mx-md-5 mx-md-10  px-md-16 mx-md-16 my-6'>
            <span class="grayblack--text"><i>Por favor, para continuar complete los siguientes datos:</i></span>
            <v-form ref="form_question">
            <v-row>
                <v-col cols="12" sm="6">
                    <v-text-field
                        v-model=firstName
                        :rules=ruleRequire
                        outlined
                        dense
                        rounded
                    >
                        <template v-slot:label>
                            <span class='gray--text font-title'> <i>Nombre *</i></span>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-text-field
                        v-model=lastName
                        :rules=ruleRequire
                        outlined
                        dense
                        rounded
                    >
                        <template v-slot:label>
                            <span class='gray--text font-title'> <i>Apellido *</i></span>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-text-field
                        v-model=email
                        :rules=ruleRequire
                        outlined
                        dense
                        rounded
                    >
                        <template v-slot:label>
                            <span class='gray--text font-title'> <i>Email *</i></span>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-text-field
                        v-model=phone
                        :rules=ruleRequire
                        outlined
                        dense
                        rounded
                        type="number"
                    >
                        <template v-slot:label>
                          <span class='gray--text font-title'> <i>Teléfono *</i></span>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols="12">
                    <v-autocomplete
                        v-model=reason
                        :items=reasons
                        item-text="name"
                        item-value="name"
                        :rules=ruleRequire
                        outlined
                        dense
                        rounded
                    >
                        <template v-slot:label>
                            <span class='gray--text font-title'> <i>Motivo de cotización *</i></span>
                        </template>
                    </v-autocomplete>
                </v-col>
                <v-col
                    cols="12"
                >
                    <v-textarea 
                        outlined 
                        rounded 
                        v-model=message
                        :rules=ruleRequire
                    >
                        <template v-slot:label>
                          <span class='gray--text font-title'><i>Escriba su consulta aquí</i></span>
                        </template>
                    </v-textarea>
                </v-col>
            </v-row>
            <v-btn 
                rounded 
                class='primary float-right white--text px-5 font-title'
                small
                @click="sendQuestion"
                style='position: relative;bottom: 80px;right:10px'
            >
                <b><i>Enviar</i></b>
            </v-btn>
        </v-form>
    </div>
    <v-overlay :value="overlay">
        <v-progress-circular
            indeterminate
            :absolute=true
            size="64"
        ></v-progress-circular>
    </v-overlay>
    <FooterComponent />
    </div>
</template>

<script>

import HeaderTopComponent from '../partials/HeaderTopComponent'
import MenuComponent from '../partials/MenuComponent'
import FooterComponent from '../partials/FooterComponent'
import BreadCrumbsComponent from '../partials/BreadCrumbsComponent'
import CardServiciosComponent from '../partials/CardServiciosComponent'
import MenuMovilComponent from '../partials/MenuMovilComponent'
import {mapState, mapMutations, mapActions} from 'vuex'
import Vue from 'vue'

export default {
    name:'IndexComponent',
    data: ()=>({
        reason:null,
        breadcrumbs:[
            {name:'Inicio',url:'/'},
            {name:'Contactos',url:'/contactos'}
        ],
        reasons:[
            {name:'Medicamentos de especialidad'},
            {name:'Análisis de laboratorio'},
            {name:'Análisis clínicos'},
            {name:'Aplicaciones'},
            {name:'Enfermería'},
            {name:'Medicamentos de especialidad a domicilio'},
            {name:'Análisis de laboratorio a domicilio'},
            {name:'Aplicaciones a domicilio'},
            {name:'Insumos y representación de marca'},
            {name:'Exámenes pre y post ocupacionales '},
            {name:'Apto médico'},
            {name:'Chequeos ocupacionales preventivos'},
            {name:'Medicina de atención primaria'}
        ],
        breadcrumb:{name:'Contacto',url:'contactos'},
        ruleRequire: [v => !!v || "El campo es obligatorio"],
        firstName:null,
        lastName:null,
        email:null,
        phone:null,
        reason:null,
        message:null,
        overlay:false,
    }),
    components:{
        HeaderTopComponent,
        MenuComponent,
        FooterComponent,
        BreadCrumbsComponent,
        CardServiciosComponent,
        MenuMovilComponent  
    },
    
    computed:{
        menuMovil(){
            return this.$vuetify.breakpoint.name == 'sm' || this.$vuetify.breakpoint.name == 'xs'
        },
        ...mapState(['scrollTop','sweealertForms'])
    },
    methods:{


        ...mapMutations(['setUrl']),


        ...mapActions(['requestApi']),
        
        sendQuestion(){

            if(!this.$refs.form_question.validate())
                return false

            this.setUrl('cotizacion-web/1')
            this.overlay=true
            this.requestApi({
				method: 'PATCH',
				data :{
                    firstName:this.firstName,
                    lastName:this.lastName,
                    email:this.email,
                    phone:this.phone,
                    reason:'consulta',
                    message:this.message,
                    reason2: this.reason
                }
			}).then(res =>{
           
                Vue.swal({
                    title: res.data.detail,
                    ...this.sweealertForms
                });
                this.firstName=null
                this.lastName=null
                this.email=null
                this.phone=null
                this.reason=null
                this.message=null

			}).catch(()=>{

            }).then(()=>{
                this.overlay=false
            })

        }

    },
    created(){
        
    }
}
</script>

<style scope>
    form fieldset {
        border:2px solid #50c995!important
    }
</style>